import React, { Component } from 'react'
import { any } from 'prop-types'
const stylesInline = {
	percentNumber: {
		fontSize: '24px',
		letterSpacing: '0.7px',
		textAlign: 'center',
		color: '#989898',
		position: 'absolute',
		width: '100%',
		top: '39%'
	}
}
export default class SpeedGraph extends Component {
	static propTypes = {
		percentage: any,
		width: any,
		height: any
	}
	constructor(props) {
		super(props)
		const percentage = (props.percentage * 100) / 180
		this.state = {
			angle: props.percentage / (percentage * 2),
			percentage: props.percentage,
			cnt: 0,
			rotate: 0
		}
		this.tickNextChange = this.tickNextChange.bind(this)
	}
	componentWillReceiveProps(nextProps) {
		const { percentage } = nextProps
		const newPercentage = (percentage * 100) / 180
		clearTimeout(this.timeout)
		this.timeout = false
		this.setState({
			angle: percentage / (newPercentage * 2),
			percentage,
			cnt: 0,
			rotate: 0
		})
		// clearTimeout(this.timeout)
		// if (percentage == 0) {
		//     clearTimeout(this.timeout)
		//     this.setState({ angle: 0, percentage, cnt: 0, rotate: 0 })
		// } else {
		//     const percentageNew = (percentage * 100) / 180
		//     this.setState({ angle: percentage / (percentageNew * 2), percentage, cnt: 0, rotate: 0 })
		//     this.tickNextChange()
		// }
	}
	componentDidMount() {
		this.tickNextChange()
	}
	componentDidUpdate() {
		if (!this.timeout) { this.tickNextChange() }
	}
	componentWillUnmount() {
		clearTimeout(this.timeout)
	}
	tickNextChange() {
		const { angle, percentage, cnt, rotate } = this.state
		const newCnt = cnt + 0.5
		const newAngle = rotate + angle
		clearTimeout(this.timeout)
		this.timeout = setTimeout(() => {
			if (percentage >= newCnt) {
				this.setState({ cnt: newCnt, rotate: newAngle })
				this.tickNextChange()
			}
		}, 1000 / (percentage * 2))
	}
	render() {
		const { width, height, percentage } = this.props
		const { rotate, cnt } = this.state
		if (this.timeout && percentage < cnt) {
			this.tickNextChange()
		}
		return (
			<div style={ { width, height, margin: 'auto', position: 'relative' } }>
				<svg width="100%" height="100%" viewBox="0 0 400 300" style={ { zIndex: '10' } }>
					<defs>
						<linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
							<stop offset="0%" style={ { stopColor: 'rgb(255,233,216)', stopOpacity: '1' } } />
							<stop offset="100%" style={ { stopColor: 'rgb(235,104,0)', stopOpacity: '1' } } />
						</linearGradient>
					</defs>
					<g>
						<path d="M350,200 a50,50 0 1,0 -300,0" fill="none" stroke="url(#grad1)" strokeWidth="4" />
					</g>
					<g id="arrow" transform={ `rotate(${ rotate } 200 200)` }>
						<path fill="rgb(235,104,0)" stroke="rgb(235,104,0)" strokeWidth="3" strokeLinecap="butt" strokeLinejoin="miter" opacity="1" d="M 54 200 L 196 200" fillOpacity="1" />
						<ellipse cx="50%" cy="200" rx="6" ry="6" fill="none" stroke="rgb(235,104,0)" strokeWidth="2.00" strokeLinecap="butt" strokeLinejoin="miter" opacity="1" />
						<ellipse cx="12.5%" cy="200" rx="6" ry="6" fill="rgb(235,104,0)" stroke="rgb(235,104,0)" strokeWidth="2.00" strokeLinecap="butt" strokeLinejoin="miter" opacity="1" />
					</g>
				</svg>
				<div style={ stylesInline.percentNumber }>{ Math.floor(cnt) }</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/SpeedGraph/SpeedGraph.js